module.exports = __webpack_public_path__ + "static/media/ico-programacion-act.7c259ace.svg";